import actions from "@/store/fs/actions";
import getters from "@/store/fs/getters";
import mutations from "@/store/fs/mutations";
import state from "@/store/fs/state";

export default {
  state,
  actions,
  mutations,
  getters,
};
